{
  "match_play": "Reikäpeli",
  "match_play_format": "Reikäpeli",
  "match_play_management": "Reikäpelihallinta",
  "play_mode": "Pelimuoto",
  "bracket": "Kaavio",
  "league": "Liiga",
  "ryder_cup": "Joukkueottelu (Ryder Cup -tyylinen)",
  "scoring_type": "Tulosten laskenta",
  "stableford": "Pistebogey",
  "stroke_play": "Lyöntipeli",
  "result_entry": "Tulosten syöttö",
  "result_only": "Vain tulos",
  "hole_by_hole": "Reikäkohtainen",
  "seeding_method": "Sijoittelumenetelmä",
  "by_handicap": "Tasoituksen mukaan",
  "random": "Satunnainen",
  "manual": "Manuaalinen",
  "hybrid_handicap_random_r0": "Hybridi (tasoitus + arvottu karsinta)",
  "manual_seeding_hint": "Voit ohittaa automaattisen sijoittelun antamalla pelaajalle haluamasi sijoitusnumeron",
  "manual_seed_aria": "Manuaalinen sijoitus",
  "duplicate_seeds_error": "Useammalle pelaajalle on annettu sama sijoitusnumero: {{seeds}}. Korjaa ennen kaavion luomista.",
  "generate_bracket": "Luo kaavio",
  "bracket_generated": "Kaavio luotu",
  "participants": "Pelaajat",
  "participant_a": "Pelaaja A",
  "participant_b": "Pelaaja B",
  "tee_time": "Klo",
  "match": "Ottelu",
  "club": "Seura",
  "handicap": "Tasoitus",
  "column_player": "Pelaaja",
  "column_seed": "Sijoitus",
  "status": "Tila",
  "result": "Tulos",
  "winner": "Voittaja",
  "result_not_available": "N/A",
  "bye": "Odottaa vastustajaa",
  "not_started": "Ei aloitettu",
  "in_progress": "Käynnissä",
  "completed": "Päättynyt",
  "enter_result": "Syötä tulos",
  "enter_match_result": "Syötä ottelun tulos",
  "select_winner": "Valitse voittaja",
  "result_notation": "Tuloksen merkintä",
  "result_notation_help": "Esim. '3/2', '1 up', 'A/S'",
  "result_notation_custom_placeholder": "Mukautettu merkintä…",
  "holes_completed": "Pelatut reiät",
  "match_format_short": "Match Play",
  "holes_played_short": "{{n}} reikää",
  "hole_range_chip": "Reiät: {{start}}–{{end}}",
  "vs_short": "vs",
  "handicap_short": "HCP",
  "result_saved": "Tulos tallennettu",
  "round_n": "Kierros {{n}}",
  "format_created": "Muoto luotu",
  "format_updated": "Muoto päivitetty",
  "format_deleted": "Muoto poistettu",
  "confirm_delete_format": "Haluatko varmasti poistaa match play -muodon?",
  "no_participations": "Ei pelaajia",
  "no_bracket_yet": "Kaaviota ei ole vielä luotu",
  "minimum_two_participants": "Vähintään kaksi pelaajaa vaaditaan",
  "unnamed_participant": "Nimeämätön pelaaja",
  "play_mode_help": "Valitse kilpailun pelimuoto",
  "scoring_type_help": "Valitse pisteidenlaskentajärjestelmä",
  "result_entry_help": "Valitse tulosten syöttötapa",
  "seeding_method_help": "Valitse sijoittelumenetelmä pelaajille",
  "setup_instructions_title": "Ohjeet:",
  "setup_step_1": "Luo match play -muoto valitsemalla pelimuoto ja pisteidenlaskenta",
  "setup_step_2": "Valitse pelaajat ja luo kaavio",
  "setup_step_3": "Syötä otteluiden tulokset sitä mukaa kun ne valmistuvat",
  "back_to_competition": "Takaisin kilpailuun",
  "select_series": "Valitse sarja",
  "no_series_available": "Kilpailulle ei ole luotu sarjoja. Luo ensin sarjat Sarjat-välilehdellä.",
  "create_format": "Luo muoto",
  "update_format": "Päivitä muoto",
  "create_bracket": "Luo kaavio",
  "recreate_bracket": "Luo kaavio uudelleen",
  "bracket_created": "Kaavio luotu",
  "no_bracket_created": "Kaaviota ei ole vielä luotu",
  "click_create_to_start": "Luo kaavio valitsemalla pelaajat ja pelimuoto.",
  "series_label": "Sarja",
  "bracket_header": "Kaavio · {{seriesName}}",
  "participants_ready": "{{count}} osallistujaa",
  "empty_state_help": "Luo kaavio valitsemalla pelimuoto ja pelaajat. Voit muokata asetuksia myöhemmin.",
  "registration_open_warning": "Huom! Ilmoittautuminen on vielä auki.",
  "panel": {
    "settings_step": "1 — Asetukset",
    "players_step": "2 — Pelaajat",
    "selected_suffix": "valittu"
  },
  "delete_format": "Poista muoto",
  "recreate_warning_title": "Varoitus: kaavio luodaan uudelleen",
  "recreate_warning_message": "Nykyinen kaavio ja kaikki tulokset poistetaan. Tätä toimintoa ei voi perua.",
  "edit_result": "Muokkaa",
  "edit_match_result": "Muokkaa ottelun tulosta",
  "clear_result": "Tyhjennä tulos",
  "result_cleared": "Tulos tyhjennetty",
  "cannot_change_winner_next_round_started": "Voittajaa ei voi vaihtaa, koska seuraavan kierroksen ottelu on jo aloitettu",
  "round_0_qualifying": "Karsintakierros",
  "qualifier_as_round1_label": "Älä näytä ensimmäistä kierrosta karsintakierroksena",
  "qualifier_as_round1_help": "Kun valittuna, mahdollinen ensimmäinen vajaa kierros on \"Kierros 1\".",
  "bronze_match": "Pronssiottelu",
  "play_bronze_match_label": "Pelaa pronssiottelu",
  "play_bronze_match_help": "Välierissä hävinneet pelaavat pronssiottelun kolmannesta sijasta.",
  "bronze_requires_two_semifinals": "Pronssiottelu vaatii kaksi välierää",
  "all_rounds": "Kaikki kierrokset",
  "delete_bracket": "Poista kaavio",
  "publish_bracket": "Julkaise kaavio",
  "hide_bracket": "Piilota kaavio",
  "bracket_not_published": "Kaaviota ei ole julkaistu.",
  "publish_bracket_link": "Julkaise.",
  "bracket_published": "Kaavio julkaistu",
  "bracket_unpublished": "Kaavio piilotettu",
  "publish_toggle_failed": "Julkaisun vaihtaminen epäonnistui",
  "edit_match": "Muokkaa ottelua",
  "match_updated": "Ottelu päivitetty",
  "match_update_failed": "Ottelun päivitys epäonnistui",
  "add_participant": "Lisää pelaaja",
  "select_participant": "Valitse pelaaja",
  "cannot_edit_participants_bracket_started": "Pelaajia ei voi muokata, koska kaavion ottelut ovat jo alkaneet",
  "confirm_delete_bracket": "Haluatko varmasti poistaa kaavion?",
  "bracket_deleted": "Kaavio poistettu",
  "bye_match_info": "Pelaaja odottaa seuraavaa vastustajaa",
  "unseated_players": "Kaavion ulkopuolella olevat pelaajat",
  "all_players_seated": "Kaikki pelaajat on sijoitettu kaavioon",
  "empty_slot": "Tyhjä paikka",
  "waiting_for_opponent": "Odottaa vastustajaa",
  "reroute": {
    "feedsInto": "Voittaja → Ottelu {{match}}",
    "winner_chip": "Voittaja",
    "success": "Karsintaottelun reititys päivitetty",
    "failed": "Karsintaottelun reititys epäonnistui"
  },
  "participant_removed": "Pelaaja poistettu",
  "participant_remove_failed": "Pelaajan poistaminen epäonnistui",
  "participant_added": "Pelaaja lisätty",
  "participant_add_failed": "Pelaajan lisääminen epäonnistui",
  "participant_moved": "Pelaaja siirretty",
  "participant_move_failed": "Pelaajan siirtäminen epäonnistui",
  "participants_swapped": "Pelaajat vaihdettu",
  "cannot_remove_last_participant_from_parent_match": "Et voi poistaa viimeistä pelaajaa ottelusta, joka syöttää seuraavalle kierrokselle. Vaihda pelaaja toiseen ensin.",
  "slot_a_waiting_for_winner_info": "Paikka A odottaa voittajaa edelliseltä kierrokselta. Voit muokata vain paikkaa B.",
  "slot_b_waiting_for_winner_info": "Paikka B odottaa voittajaa edelliseltä kierrokselta. Voit muokata vain paikkaa A.",
  "show_bracket": "Koko kaavio",
  "show_full_bracket": "Näytä koko kaavio",
  "bracket_tree": "Ottelukaavio",
  "bracket_round_number_qualifier": "Q",
  "finals": "Finaali",
  "semi_finals": "Välierät",
  "quarter_finals": "Puolivälierät",
  "tee": "Tii",
  "tabs": {
    "format": "Muoto",
    "bracket": "Kaavio",
    "match_configurations": "Ottelukonfiguraatiot"
  },
  "match_configs": {
    "title": "Ottelukonfiguraatiot",
    "add": "Lisää konfiguraatio",
    "edit": "Muokkaa konfiguraatiota",
    "edit_title": "Muokkaa konfiguraatiota",
    "delete": "Poista konfiguraatio",
    "delete_blocked": "Konfiguraatiota ei voi poistaa, koska se on käytössä",
    "deleted": "Konfiguraatio poistettu",
    "duplicated": "Konfiguraatio kopioitu",
    "duplicate": "Kopioi",
    "duplicate_default_name_suffix": " (kopio)",
    "show_usages": "Näytä käyttö",
    "empty": "Ei konfiguraatioita",
    "scratch_label": "Ei kenttävalintaa (vain scratch)",
    "no_default": "Ei oletusta",
    "create_new": "+ Luo uusi konfiguraatio...",
    "holes_suffix": " reikää",
    "override_indicator_tooltip": "Ottelulla on oma konfiguraatio",
    "confirm_edit_count": "Käytössä {{matchCount}} ottelussa ({{finalisedCount}} päättynyttä) ja {{roundCount}} kierroksen oletuksena. Jatketaanko?",
    "usage_summary": "Käytössä {{matchCount}} ottelussa ({{finalisedCount}} päättynyttä) ja {{roundCount}} kierroksen oletuksena.",
    "fields": {
      "name": "Nimi",
      "scorecard": "Tuloskortti",
      "mens_tee": "Miesten tiipaikka",
      "womens_tee": "Naisten tiipaikka",
      "start_hole": "Aloitusreikä",
      "end_hole": "Lopetusreikä",
      "handicap_factor": "Tasoituskerroin",
      "men_max_handicap": "Miesten max. tasoitus",
      "women_max_handicap": "Naisten max. tasoitus",
      "team_handicap_percentages": "Joukkuetasoituksen prosentit (CSV)",
      "limit_team_handicap_to_min_slope": "Rajoita joukkueen tasoitus pienimpään yksilötasoitukseen",
      "holes_range": "Reiät"
    },
    "help": {
      "team_handicap_percentages": "0.5,0.5 – Foursomes\n0.6,0.4 – Greensome\n0.35,0.15 – 2-pelaajan Scramble\n0.25,0.20,0.15,0.10 – 4-pelaajan Scramble"
    },
    "validation": {
      "name_required": "Nimi on pakollinen",
      "end_hole": "Lopetusreiän on oltava suurempi tai yhtä suuri kuin aloitusreikä"
    }
  },
  "round_defaults": {
    "edit_title": "Asetukset - {{round}}",
    "deadline_label": "Takaraja",
    "deadline_chip": "Takaraja: {{date}}",
    "fixed_date_label": "Kiinteä päivämäärä",
    "fixed_date_chip": "{{date}}"
  },
  "match_edit": {
    "config_label": "Konfiguraatio",
    "use_round_default_named": "Käytä kierroksen oletusta — {{name}}",
    "use_round_default_no_config": "Käytä kierroksen oletusta (ei konfiguraatiota)"
  },
  "tvBoard": {
    "noMatches": "Ei otteluita",
    "player": "Pelaaja",
    "result": "Tulos",
    "thru": "Pel."
  },
  "public": {
    "notYetPublished": "Kaaviota ei ole vielä julkaistu",
    "seriesSelectorLabel": "Sarja"
  },
  "maximum_score": "Maksimitulos",
  "match_config_details": {
    "title": "Ottelukonfiguraatio",
    "scratch": "Konfiguraatiota ei ole asetettu — ottelu pelataan scratchina ilman kenttävalintaa.",
    "scratch_label": "Scratch",
    "course": "Kenttä",
    "mens_tee": "Miesten tii",
    "womens_tee": "Naisten tii",
    "hole_range": "Reiät",
    "handicap_factor": "Tasoituskerroin",
    "men_max_handicap": "Miesten max. tasoitus",
    "women_max_handicap": "Naisten max. tasoitus",
    "team_handicap_percentages": "Joukkuetasoitus (CSV)",
    "limit_team_handicap_to_min_slope": "Joukkueen tasoituksen yläraja",
    "enabled": "Käytössä"
  },
  "bracket_properties": {
    "title": "Kaavion ominaisuudet",
    "game_mode": "Pelimuoto",
    "scoring_format": "Tulosten laskenta",
    "draw_decision": "Tasapelin ratkaisu",
    "handicap": "Tasoitus",
    "handicap_scratch": "Scratch",
    "handicap_with_factor": "Tasoituksellinen ({{percent}} %)",
    "handicap_varies": "Vaihtelee — katso ottelukonfiguraatiot"
  },
  "tieBreakMode": {
    "label": "Tasapelin ratkaisu",
    "EXTRA_HOLES": "Jatkoreiät",
    "MATHEMATICAL": "Matemaattinen (9/6/3/1)",
    "HANDICAP_LOWER": "Alempi tasoitus",
    "PLAYING_HANDICAP_LOWER": "Alempi pelitasoitus"
  },
  "scoring": {
    "title": "Kierrostulosten syöttö",
    "handicapBadge": "(HCP: {{value}})",
    "strokesReceivedThisHole_one": "Tasoitus: {{count}} lyönti",
    "strokesReceivedThisHole_other": "Tasoitus: {{count}} lyöntiä",
    "matchState": "Tilanne",
    "allSquare": "A/S",
    "level": "Tasan",
    "up": "UP",
    "missingScore": "Tulos puuttuu",
    "down": "DOWN",
    "holesRemaining": "reikiä jäljellä",
    "matchComplete": "Ottelu päättynyt",
    "matchCompleteBadge": "VOITTAA OTTELUN",
    "winsMatch": "voittaa ottelun",
    "winner": "Voittaja",
    "hole": "Reikä",
    "playoff": "jatko",
    "strokes": "Lyönnit",
    "pickedUp": "Poimi pallo",
    "conceded": "Luovutus",
    "won": "Voitto",
    "lost": "Häviö",
    "halved": "Tasapeli",
    "thru": "pelattu",
    "enterScore": "Reikäkohtainen tulos",
    "saveScore": "Tallenna",
    "front9": "Reiät 1-9",
    "back9": "Reiät 10-18",
    "endGame": "Päätä ottelu",
    "matchSummary": "Ottelun yhteenveto",
    "confirmResult": "Vahvista tulos",
    "resetScores": "Tyhjennä tulokset",
    "resetShort": "Tyhjennä",
    "resetScoresConfirm": "Haluatko varmasti tyhjentää kaikki ottelun tulokset? Tätä toimintoa ei voi perua.",
    "scorecardRequired": "Tuloskortti puuttuu — määritä tuloskortti tulosten laskentaa varten",
    "leadsBy": {
      "matchplay": "{{name}} johtaa {{margin}} reiällä",
      "strokes": "{{name}} johtaa {{margin}} lyönnillä",
      "points": "{{name}} johtaa {{margin}} pisteellä"
    },
    "tied": {
      "matchplay": "Tasan",
      "strokes": "Tasapeli — {{total}}",
      "points": "Tasapeli — {{total}} p"
    },
    "winsMatchBy": {
      "strokes": "Voittaa ottelun {{margin}} lyönnillä",
      "points": "Voittaa ottelun {{margin}} pisteellä"
    }
  },
  "ryderCup": {
    "title": "Joukkueottelu",
    "management_title": "Joukkueottelun hallinta",
    "create": "Luo joukkueottelu",
    "players_assigned_next": "Pelaajat jaetaan joukkueisiin hallintanäkymässä seuraavaksi.",
    "create": "Luo joukkueottelu",
    "players_assigned_next": "Pelaajia ei valita tässä — heidät jaetaan joukkueisiin seuraavassa vaiheessa joukkueottelun hallinnassa.",
    "tab_teams": "Joukkueet",
    "tab_sessions": "Jaksot",
    "tab_scoreboard": "Tulokset",
    "team_name": "Joukkueen nimi",
    "team_colour": "Joukkueen väri",
    "no_members": "Ei pelaajia",
    "unassigned": "Ei joukkuetta",
    "move_to_team_right": "{{team}} →",
    "move_to_team_left": "← {{team}}",
    "unequal_team_sizes_warning": "Joukkueiden koot eroavat ({{a}} vs {{b}} pelaajaa)",
    "session": "Jakso",
    "session_default": "Jakso {{number}}",
    "add_session": "Luo jakso",
    "session_name": "Nimi",
    "delete_session": "Poista jakso",
    "delete_session_confirm": "Haluatko varmasti poistaa jakson ja kaikki sen ottelut?",
    "add_match": "Lisää ottelu",
    "select_player": "Valitse pelaaja",
    "already_in_session": "Jo ottelussa",
    "delete_match": "Poista ottelu",
    "delete_match_confirm": "Haluatko varmasti poistaa tämän ottelun?",
    "delete_result": "Poista tulos",
    "delete_result_confirm": "Haluatko varmasti poistaa tämän ottelun tuloksen? Ottelu palautuu pelaamattomaksi.",
    "error_same_team": "Molemmat pelaajat ovat samassa joukkueessa",
    "error_duplicate_in_session": "Pelaaja on jo tässä jaksossa",
    "no_sessions_yet": "Ei jaksuja. Luo ensin jakso.",
    "no_matches_in_session": "Ei otteluita tässä jaksossa.",
    "finalize_as": "Päätä A/S (tasapeli)",
    "finalize_as_confirm": "Haluatko varmasti päättää ottelun tasapelinä (A/S)?",
    "finalize_as_header": "Päätä ottelu A/S",
    "enter_result": "Syötä tulos",
    "edit_result": "Muokkaa tulosta",
    "reopen_match": "Avaa ottelu uudelleen",
    "reopen_match_confirm": "Ottelu on jo päättynyt. Tuloksen muokkaaminen avaa ottelun uudelleen ja poistaa nykyisen tuloksen (väyläkohtaiset tulokset säilyvät), kunnes vahvistat sen uudelleen. Joukkueen piste poistuu tulostaulusta siihen asti. Jatketaanko?",
    "reopen_match_confirm_action": "Avaa uudelleen",
    "score": "Tulos",
    "confirm_finish": "Haluatko varmasti päättää ottelun? Tulos lasketaan syötetyistä tuloksista (tasatilanteessa A/S).",
    "team_wins": "{{team}} voittaa",
    "halved_as": "Tasapeli (A/S)",
    "result_notation": "Tuloksen merkintä",
    "result_notation_placeholder": "esim. 3&2, 1 up",
    "edit_schedule": "Muokkaa aikataulua",
    "start_date": "Päivä",
    "start_time": "Aloitusaika",
    "start_tee": "Aloitusväylä",
    "tee_n": "Väylä {{n}}",
    "scoreboard": "Tulokset",
    "session_breakdown": "Jaksokohtaiset pisteet",
    "team": "Joukkue",
    "actual": "Pisteet",
    "projected": "Ennuste",
    "projected_short": "Ennuste",
    "tie": "Tasapeli",
    "wins": "voittaa",
    "scoreboard_not_available": "Joukkueottelun tulostaulu ei ole saatavilla",
    "as_short": "A/S",
    "up_short": "UP",
    "final_short": "Loppu",
    "halved_short": "Tasan",
    "thru_short": "Pel.",
    "time_short": "klo",
    "session_settings": "Jakson asetukset",
    "publish": "Julkaise ottelut",
    "unpublish": "Piilota ottelut",
    "not_published": "Tuloksia ei ole vielä julkaistu.",
    "publish_link": "Julkaise.",
    "published": "Ottelut julkaistu",
    "unpublished": "Ottelut piilotettu",
    "delete": "Poista joukkueottelu",
    "confirm_delete_title": "Poista joukkueottelu?",
    "confirm_delete_body": "Tämä poistaa joukkueet, jaksot ja ottelut pysyvästi. Toimintoa ei voi perua.",
    "deleted": "Joukkueottelu poistettu",
    "props": {
      "game_mode": "Joukkueottelu",
      "scoring": "Reikäpeli"
    }
  }
}
